import { INIT_SETTING_PRINT } from '../types';
import { InitSettingPrint } from './../../dataType/Setting';
export const initSettingPrint = (data: InitSettingPrint) => ({
  type: INIT_SETTING_PRINT,
  payload: data
})